import { render, staticRenderFns } from "./tdSso.vue?vue&type=template&id=09dee136&scoped=true"
import script from "./tdSso.vue?vue&type=script&lang=js"
export * from "./tdSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dee136",
  null
  
)

export default component.exports